import * as PIXI from 'pixi.js';
import gsap from 'gsap';
import CardContainer from "./cardContainer";
import AssetsLoader from '../utils/assetsLoader';
import { CARD_WIDTH, CARD_HEIGHT, RESOLUTION } from '../utils/commonUtils';

class LifeCardsContainer extends PIXI.Container {
    constructor(lifeCount, isOpponent = false) {
        super();

        const mainDeckCardBackTexture = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.MAIN_DECK_CARD_BACK);

        for (let i = 0; i < lifeCount; i++) {
            const mainDeckCardBackSprite = new PIXI.Sprite(mainDeckCardBackTexture);
            mainDeckCardBackSprite.width = CARD_WIDTH*RESOLUTION;
            mainDeckCardBackSprite.height = CARD_HEIGHT*RESOLUTION;
            mainDeckCardBackSprite.anchor.set(0.5, 1);
            mainDeckCardBackSprite.angle = isOpponent ? -90 : 90;
            mainDeckCardBackSprite.x = 0;
            mainDeckCardBackSprite.y = -i -(CARD_HEIGHT*RESOLUTION) * (i / lifeCount);
            this.addChild(mainDeckCardBackSprite);
        }
    }

    updateLifeCount(originalLifeCount, newLifeCount, isOpponent = false) {
        this.removeChildren();
        const mainDeckCardBackTexture = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.MAIN_DECK_CARD_BACK);
        for (let i = 0; i < newLifeCount; i++) {
            const mainDeckCardBackSprite = new PIXI.Sprite(mainDeckCardBackTexture);
            mainDeckCardBackSprite.width = CARD_WIDTH*RESOLUTION;
            mainDeckCardBackSprite.height = CARD_HEIGHT*RESOLUTION;
            mainDeckCardBackSprite.anchor.set(0.5, 1);
            mainDeckCardBackSprite.angle = isOpponent ? -90 : 90;
            mainDeckCardBackSprite.x = 0;
            mainDeckCardBackSprite.y = -i -(CARD_HEIGHT*RESOLUTION) * (i / originalLifeCount);
            this.addChild(mainDeckCardBackSprite);
        }
    }
    
    
}

export default class LeaderContainer extends PIXI.Container {
    constructor(playerState, isOpponent = false) {
        super();

        this.isOpponent = isOpponent;

        const leaderFrame = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.LEADER_FRAME);
        const leaderFrameSprite = new PIXI.Sprite(leaderFrame);
        leaderFrameSprite.anchor.set(0.5, 1);
        this.addChild(leaderFrameSprite);

        const lifeCardsContainer = new LifeCardsContainer(playerState.lifeCount, isOpponent);
        lifeCardsContainer.label = 'lifeCardsContainer';
        lifeCardsContainer.x = !isOpponent ? 40*RESOLUTION : -14*RESOLUTION;
        lifeCardsContainer.y = -120*RESOLUTION;
        lifeCardsContainer.scale.set(0.55);
        this.addChild(lifeCardsContainer);

        this.leaderCard = new CardContainer(playerState.leader, { powerTextYOffset: 50 });
        this.leaderCard.x = 13*RESOLUTION;
        this.leaderCard.y = -55*RESOLUTION;
        this.leaderCard.scale.set(0.92);
        // this.leaderCard.hidePowerText();
        this.addChild(this.leaderCard);

        const leaderPowerText = new PIXI.Text({
            text: playerState.leader.currentPower,
            style: {
                fontFamily: 'Fugaz One',
                fontSize: 45*RESOLUTION,
                fill: '#ffffff',
                stroke: { color: '#000000', width: 10*RESOLUTION },
            },
        });
        leaderPowerText.label = 'leaderPowerText';
        leaderPowerText.anchor.set(0.5, 1);
        leaderPowerText.x = 13*RESOLUTION;
        leaderPowerText.y = -10*RESOLUTION;
        leaderPowerText.visible = false;
        this.addChild(leaderPowerText);

        const lifeContainer = new PIXI.Container();
        lifeContainer.label = 'lifeContainer';
        lifeContainer.x = !isOpponent ? 100*RESOLUTION : -72*RESOLUTION;
        lifeContainer.y = -72*RESOLUTION;

        const lifeIcon = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.LIFE_ICON);
        const lifeIconSprite = new PIXI.Sprite(lifeIcon);
        lifeIconSprite.anchor.set(0.5, 0.5);
        lifeIconSprite.x = 0;
        lifeIconSprite.y = 0;
        lifeContainer.addChild(lifeIconSprite);

        const lifeText = new PIXI.Text({
            text: playerState.lifeCount,
            style: {
                fontFamily: 'Fugaz One',
                fontSize: 50*RESOLUTION,
                fill: '#ffffff',
                stroke: { color: '#000000', width: 10*RESOLUTION },
            },
        });
        lifeText.label = 'lifeText';
        lifeText.anchor.set(0.5, 0.5);
        lifeText.x = 3*RESOLUTION;
        lifeText.y = -10*RESOLUTION;
        lifeContainer.addChild(lifeText);
        this.addChild(lifeContainer);
    }

    update(playerState, clientGameState) {
        this.leaderCard.updateCardInstance(playerState.leader);
        // this.leaderCard.hidePowerText();
        const leaderPowerText = this.getChildByLabel('leaderPowerText');
        leaderPowerText.text = playerState.leader.currentPower;

        let fillColor;
        if (playerState.leader.currentPower > playerState.leader.power) {
            fillColor = '#fbe64e';
        } else if (playerState.leader.currentPower === playerState.leader.power) {
            fillColor = '#ffffff';
        } else {
            fillColor = '#ff0000';
        }
        leaderPowerText.style.fill = fillColor;

        const lifeContainer = this.getChildByLabel('lifeContainer');
        const lifeText = lifeContainer.getChildByLabel('lifeText');
        lifeText.text = playerState.lifeCount;

        const lifeCardsContainer = this.getChildByLabel('lifeCardsContainer');
        lifeCardsContainer.updateLifeCount(playerState.leader.life, playerState.lifeCount, this.isOpponent);

        if (
            clientGameState?.selectableCards?.includes(playerState.leader.instanceId) ||
            playerState.leader.attachedDon.some(don => clientGameState?.selectableCards?.includes(don.instanceId))
        ) {
            if (clientGameState.selectedCard === playerState.leader.instanceId) {
                this.leaderCard.setHighlightSelected();
            } else {
                this.leaderCard.setHighlightSelectable();
            }
        }

        const selectedDonsForReturn = playerState.leader.attachedDon.filter(don => clientGameState?.donsSelectedForReturn?.includes(don.instanceId));
        if (selectedDonsForReturn.length) {
            this.leaderCard.setDonsForReturnCounter(selectedDonsForReturn.length);
        }

        if (clientGameState?.validAttackTargets?.includes(playerState.leader.instanceId)) {
            this.leaderCard.setHighlightAttackTarget();
        }
    }

    unhighlightCard() {
        this.leaderCard.unhighlightCard();
    }

    highlightCard() {
        this.leaderCard.highlightCard();
    }

    async playDrawTopLifeCardAnimation() {
        const lifeCardsContainer = this.getChildByLabel('lifeCardsContainer');
        const lifeCards = lifeCardsContainer.children;
        const lifeCard = lifeCards[lifeCards.length - 1];
        lifeCard.anchor.set(0.5, 0.5);
        lifeCard.x = lifeCard.height / 2;

        await gsap.timeline().timeScale(1.2).to(lifeCard, {
            duration: 0.5,
            ease: 'power2.in',
            pixi: {
                x: '+=150',
                angle: 0,
                scaleX: 0,
            }
        });

        return lifeCard;
    }
}

